import { useCallback, useEffect, useState } from 'react';

// `getIsDirty` is a getter, not a boolean, so dirtiness can be read from live
// form values on demand without re-rendering this hook on every keystroke.
const useUnsavedChangesPrompt = ({ getIsDirty, onClose, onSave }) => {
  const [isPromptOpen, setIsPromptOpen] = useState(false);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (!getIsDirty()) return;
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [getIsDirty]);

  const requestClose = useCallback(() => {
    if (getIsDirty()) {
      setIsPromptOpen(true);
    } else {
      onClose();
    }
  }, [getIsDirty, onClose]);

  const closePrompt = useCallback(() => setIsPromptOpen(false), []);

  const handleDiscard = useCallback(() => {
    setIsPromptOpen(false);
    onClose();
  }, [onClose]);

  const handleSave = useCallback(() => {
    setIsPromptOpen(false);
    onSave();
  }, [onSave]);

  return { requestClose, isPromptOpen, closePrompt, handleDiscard, handleSave };
};

export default useUnsavedChangesPrompt;
